module.exports = __webpack_public_path__ + "img/social-sms.da8088d2.svg";